import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import SectionComponent from "components/common/Section/SectionComponent";
import ReadOnlyFormGroup from "components/common/ReadOnlyFormGroup";
import Routes from "routing/Routes";
import { Link } from "components/common";
import AppConfig from "util/AppConfig";
const _getSourceType = (t, authServiceId, type = "unknown") => {
  if (type === "SYNCED" && authServiceId) {
    return /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "team_details_profile.synced_with_auth_service",
        values: { type: type.toLowerCase() },
        components: { authServiceLink: /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.show(authServiceId) }) }
      }
    );
  }
  return type.toLowerCase();
};
const isCloud = AppConfig.isCloud();
const ProfileSection = ({ team: { authServiceId, description, name, type } }) => {
  const { t } = useTranslation("enterprise_security");
  const sourceType = _getSourceType(t, authServiceId, type);
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: t("team_details_profile.title") }, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("team_details_profile.name"), value: name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("team_details_profile.description"), value: description }), !isCloud && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("team_details_profile.source"), value: sourceType }));
};
export default ProfileSection;
